//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "../IconView.vue";
import { gsap } from 'gsap'
import { datesToHuman } from "../../../utils/dates.js";
import throttle from "lodash/throttle";
import cloneDeep from "lodash/cloneDeep";
import chunk from "lodash/chunk";
import concat from "lodash/concat";
import { v4 as uuidv4 } from 'uuid';
import { Skeleton } from "ant-design-vue";
import "ant-design-vue/es/skeleton/style/index.css"
import { adjustColorBrightness, buildMaskStyle } from "@/utils/helpers.js";
import { DesignExtra } from "@/utils/dto/objects.js";
import TheMaskIcon from '@/components/objects/TheMaskIcon.vue';

export default {
  name: "EventsShorts",
  components: {
    IconView,
    'a-skeleton': Skeleton,
    TheMaskIcon,
  },
  inject: {
    source: {}
  },
  props: {
    itemsList: {
      type: Array,
      default: () => {
        return []
      }
    },
    label: {
      type: String,
      default: ''
    },
    listInfo: {
      type: Object,
    },
    domId: {
      type: String,
      default: ''
    },
    detail: {
      type: Boolean,
    },
    template: {
      type: Object,
    },
    user: {
      type: Object,
      default: () => {}
    },
    design: {
      type: String,
    },
    theme: {
      type: String,
      default: () => 'default'
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => {}
    },
  },
  data() {
    return {
      rowSize: 5,
      ready: false,
      items: [],
      showLargeArrow: false,
      scrollObserver: null,
      animatedItems: null,
    }
  },
  watch: {
    'itemsList.length'() {
      if (!this.ready) return
      this.$nextTick(() => {
        this.setupScrollAnimations()
      })
    },
  },
  computed: {
    enrichItems() {
      return this.enrichListV2([
        { label: this.label, fake: true, first: true },
        ...cloneDeep(this.itemsList),
        ...new Array(this.calcNumToAdd([{ label: this.label, fake: true }, ...this.itemsList], this.rowSize)).fill({ fake: true, id: uuidv4() })
      ], this.rowSize)
        .map((item, i) => {
          item.isLast = i === this.itemsList.length - 1 + 1 // +1 из-за первого фейка


          if (item.fake || item.loader) return item

          if (item.use_full_label) {
            item.humanLabel = item.target_object.label || item.target_object.short_label
          } else {
            item.humanLabel = item.target_object.short_label || item.target_object.label
          }

          return item
        })
    },
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    bgPalette() {
      if (this.design_extra?.bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.bg.palette)[0];
      }

      return null;
    },
    iconBorderPalette() {
      if (this.design_extra?.icon_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_border.palette)[0];
      }

      return null;
    },
    iconBgPalette() {
      if (this.design_extra?.icon_bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_bg.palette)[0];
      }

      return null;
    },
    getTextColor() {
      return this.design_extra?.text?.color ?? null;
    },
    getIconColor() {
      return this.design_extra?.icon_color?.color ?? 'vistat';
    },
    getIconGradientEnabled() {
      return this.design_extra?.icon_bg?.gradient_enabled ?? null;
    },
    getIconGradientDirection() {
      return this.design_extra?.icon_bg?.gradient_direction ?? null;
    },
    getIconGradientShadowDirection() {
      return this.design_extra?.icon_bg?.gradient_shadow_direction ?? null;
    },
    getMask() {
      return this.design_extra?.mask?.name ?? null;
    },
    getFirstBlockBg() {
      if (this.getFirstBlockBgGradientEnabled) {
        return `linear-gradient(to ${this.getBgGradientDirection}, ${this.getBgGradientShadowDirection === 'transparent' ? `${this.getFirstBlockBgColor}, transparent` : `${this.getFirstBlockBgColor}, ${adjustColorBrightness((this.getFirstBlockBgColor), 1.20)}`})`
      } else if (this.design_extra?.first_block?.gradient_enabled && this.design_extra?.first_block?.bg_color) {
        return `linear-gradient(to ${this.getFirstBlockBgGradientDirection}, ${this.getFirstBlockBgGradientShadowDirection === 'transparent' ? `${this.getFirstBlockBgColor}, transparent` : `${this.getFirstBlockBgColor}, ${adjustColorBrightness((this.getFirstBlockBgColor), 1.20)}`})`
      }

      return this.getFirstBlockBgColor;
    },
    getFirstBlockBgColor() {
      return this.design_extra?.first_block?.bg_color ?? this.getIconBgColor(0) ?? null;
    },
    getFirstBlockBgGradientEnabled() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.icon_bg?.gradient_enabled ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_enabled ?? null;
      }
    },
    getFirstBlockBgGradientDirection() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.icon_bg?.gradient_direction ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_direction ?? null;
      }
    },
    getFirstBlockBgGradientShadowDirection() {
      if (this.hasNotFirstBlockBgAndHasBgPalette) {
        return this.design_extra?.icon_bg?.gradient_shadow_direction ?? null;
      } else {
        return this.design_extra?.first_block?.gradient_shadow_direction ?? null;
      }
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color ?? null;
    },
    getFirstBlockIconBorderColor() {
      return this.design_extra?.first_block?.icon_border_color ?? null;
    },
    hasNotFirstBlockBgAndHasBgPalette() {
      if (!this.design_extra?.first_block?.bg_color && this.bgPalette) {
        return true;
      } else return false;
    },
  },
  mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      window.addEventListener('resize', this.resizeHandler, { passive: true })
      window.addEventListener('vistat:prepare-export', this.finishScrollAnimationsForExport)

      this.$nextTick(() => {
        this.ready = true

        this.$nextTick(() => {
          this.computeRowSize()
          this.setupScrollAnimations()
        })
      })
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
    window.removeEventListener('vistat:prepare-export', this.finishScrollAnimationsForExport)
    this.teardownScrollAnimations()
  },
  methods: {
    isScrollExportTarget(event) {
      const element = event?.detail?.element
      return !!(element && this.$el && (this.$el === element || this.$el.contains(element) || element.contains(this.$el)))
    },
    finishScrollAnimationsForExport(event) {
      if (!this.isScrollExportTarget(event)) return

      if (this.scrollObserver) {
        this.scrollObserver.disconnect()
        this.scrollObserver = null
      }
      this.stopAllTweens()
      const animatedTargets = [
        ...this.$el.querySelectorAll('.event__date, .event__icon, .event__label, .event__list-next-step, .event__list-del, .event__icon-arrow-mob'),
      ].filter(Boolean)
      gsap.killTweensOf(animatedTargets)
      gsap.set(animatedTargets, { clearProps: 'transform,opacity' })
      this.animatedItems = new WeakSet()
    },
    addTween(tween) {
      if (!this._activeGsapTweens) this._activeGsapTweens = new Set()
      if (!tween) return tween
      this._activeGsapTweens.add(tween)
      tween.eventCallback('onComplete', () => this._activeGsapTweens.delete(tween))
      return tween
    },
    stopAllTweens() {
      if (!this._activeGsapTweens) return
      this._activeGsapTweens.forEach((tween) => tween.kill())
      this._activeGsapTweens.clear()
    },
    teardownScrollAnimations() {
      if (this.scrollObserver) {
        this.scrollObserver.disconnect()
        this.scrollObserver = null
      }
      this.stopAllTweens()
      this.animatedItems = null
    },
    isScrollAnimationEnabled() {
      if (typeof window === 'undefined') return false
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    },
    clearGsapInlineStyles(elements, props = 'transform') {
      elements.filter(Boolean).forEach((el) => gsap.set(el, { clearProps: props }))
    },
    setupScrollAnimations() {
      if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') return
      if (!this.$refs['list-items'] || !this.ready) return

      if (!this.animatedItems) {
        this.animatedItems = new WeakSet()
      }

      if (!this.isScrollAnimationEnabled()) return

      if (!this.scrollObserver) {
        this.scrollObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return
            this.animateListItem(entry.target)
            this.scrollObserver.unobserve(entry.target)
          })
        }, {
          threshold: 0.12,
          rootMargin: '60px 0px',
        })
      }

      this.$refs['list-items'].querySelectorAll('li[data-scroll-item]').forEach((item) => {
        if (this.animatedItems.has(item)) return
        this.prepareListItem(item)
        this.scrollObserver.observe(item)
      })
    },
    isFlippedLine(event, type) {
      return (type === 'nextStep' && event.classList.contains('event--odd'))
        || (type === 'listDel' && event.classList.contains('event--is-start-row'))
    },
    getLineScaleProps(event, type) {
      if (this.isFlippedLine(event, type)) {
        return {
          from: { opacity: 0 },
          to: { opacity: 1 },
          preserveCssTransform: true,
        }
      }

      if (type === 'nextStep') {
        return {
          from: { opacity: 0, scaleX: 0, transformOrigin: 'left center' },
          to: { opacity: 1, scaleX: 1, transformOrigin: 'left center' },
          preserveCssTransform: false,
        }
      }

      return {
        from: { opacity: 0, scaleX: 0, transformOrigin: 'left top' },
        to: { opacity: 1, scaleX: 1, transformOrigin: 'left top' },
        preserveCssTransform: false,
      }
    },
    finishLineAnimation(el, preserveCssTransform) {
      if (preserveCssTransform) {
        gsap.set(el, { clearProps: 'opacity' })
        return
      }
      gsap.set(el, { clearProps: 'transform,opacity' })
    },
    prepareListItem(li) {
      const event = li.querySelector('.event')
      if (!event) return

      const icon = event.querySelector('.event__icon')
      const date = event.querySelector('.event__date')
      const label = event.querySelector('.event__label')
      const nextStep = event.querySelector('.event__list-next-step')
      const listDel = event.querySelector('.event__list-del')
      const mobArrow = event.querySelector('.event__icon-arrow-mob')
      const isFake = event.classList.contains('event--fake')

      if (isFake) {
        if (icon) {
          gsap.set(icon, { opacity: 0, scale: 0.9, y: 10, transformOrigin: 'center center' })
        }
      } else {
        const contentTargets = [date, icon, label].filter(Boolean)
        gsap.set(contentTargets, { opacity: 0, y: 10, scale: 0.94 })
        if (icon) gsap.set(icon, { transformOrigin: 'center center' })
      }

      if (nextStep) {
        gsap.set(nextStep, this.getLineScaleProps(event, 'nextStep').from)
      }

      if (listDel) {
        gsap.set(listDel, this.getLineScaleProps(event, 'listDel').from)
      }

      if (mobArrow) {
        gsap.set(mobArrow, { opacity: 0, y: -6 })
      }
    },
    animateListItem(li) {
      if (this.animatedItems?.has(li)) return
      this.animatedItems.add(li)

      const event = li.querySelector('.event')
      if (!event) return

      const icon = event.querySelector('.event__icon')
      const date = event.querySelector('.event__date')
      const label = event.querySelector('.event__label')
      const nextStep = event.querySelector('.event__list-next-step')
      const listDel = event.querySelector('.event__list-del')
      const mobArrow = event.querySelector('.event__icon-arrow-mob')
      const isFake = event.classList.contains('event--fake')
      const contentTargets = [date, icon, label].filter(Boolean)

      const timeline = gsap.timeline({
        onComplete: () => {
          this.clearGsapInlineStyles(isFake ? [icon] : contentTargets)
          this.clearGsapInlineStyles([mobArrow])
        },
      })

      if (isFake) {
        if (icon) {
          timeline.to(icon, {
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 1.38,
            ease: 'back.out(1.4)',
          }, 0)
        }
      } else {
        timeline.to(contentTargets, {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.36,
          stagger: 0.04,
          ease: 'back.out(1.35)',
        }, 0)
      }

      if (listDel) {
        const line = this.getLineScaleProps(event, 'listDel')
        timeline.to(listDel, {
          ...line.to,
          duration: line.preserveCssTransform ? 0.62 : 0.52,
          ease: 'power2.out',
          onComplete: () => this.finishLineAnimation(listDel, line.preserveCssTransform),
        }, 0.15)
      }

      if (nextStep) {
        const line = this.getLineScaleProps(event, 'nextStep')
        timeline.to(nextStep, {
          ...line.to,
          duration: line.preserveCssTransform ? 0.68 : 0.58,
          ease: 'power2.out',
          onComplete: () => this.finishLineAnimation(nextStep, line.preserveCssTransform),
        }, 0.15)
      }

      if (mobArrow) {
        timeline.to(mobArrow, {
          opacity: 1,
          y: 0,
          duration: 0.56,
          ease: 'power2.out',
        }, 0.22)
      }

      this.addTween(timeline)
    },
    maskStyle(mask) {
      return buildMaskStyle(mask)
    },
    getIconBorderColor(index) {
      if (this.iconBorderPalette) {
        return [this.iconBorderPalette.main_color, ...this.iconBorderPalette.colors][index < 0 ? 0 : index % [this.iconBorderPalette.main_color, ...this.iconBorderPalette.colors].length];
      } else if (this.design_extra?.icon_border?.color) {
        return this.design_extra.icon_border.color
      }

      return 'transparent';
    },
    getBgColor(index) {
      if (this.bgPalette) {
        return [this.bgPalette.main_color, ...this.bgPalette.colors][index % [this.bgPalette.main_color, ...this.bgPalette.colors].length];
      } else if (this.design_extra?.bg?.color) {
        return this.design_extra.bg.color
      }

      return null;
    },
    getIconBgColor(index) {
      if (this.getIconGradientEnabled) {
        if (this.iconBgPalette) {
          const color = [this.iconBgPalette.main_color, ...this.iconBgPalette.colors][index % [this.iconBgPalette.main_color, ...this.iconBgPalette.colors].length];
          return `linear-gradient(to ${this.getIconGradientDirection}, ${this.getIconGradientShadowDirection === 'transparent' ? `${color}, transparent` : `${color}, ${adjustColorBrightness(color, 1.20)}`})`
        } else if (this.design_extra?.icon_bg?.color) {
          const color = this.design_extra.icon_bg.color;
          return `linear-gradient(to ${this.getIconGradientDirection}, ${this.getIconGradientShadowDirection === 'transparent' ? `${color}, transparent` : `${color}, ${adjustColorBrightness(color, 1.20)}`})`
        }
      } else {
        if (this.iconBgPalette) {
          return [this.iconBgPalette.main_color, ...this.iconBgPalette.colors][index % [this.iconBgPalette.main_color, ...this.iconBgPalette.colors].length];
        } else if (this.design_extra?.icon_bg?.color) {
          return this.design_extra.icon_bg.color
        }
      }

      return null;
    },
    getDates(event_date) {
      return datesToHuman({
        value: event_date.vfrom,
      }, {
        value: event_date.vto
      }, "object")
    },
    computeRowSize() {
      const containerWidth = this.$refs["list-items"].clientWidth
      this.rowSize = Math.ceil((containerWidth - 94 * 2) / 150)
      this.$refs["list-items"].style.setProperty(
        '--gap-size',
        `${(containerWidth - (96 * 2) - (60 * this.rowSize)) / (this.rowSize - 1)}px`);

      let baseVerticalGap = 110
      this.$refs["list-items"].querySelectorAll('h3').forEach(x => {
        if (x.clientHeight > 40) {
          baseVerticalGap = 140
        }
      })
      this.$refs["list-items"].style.setProperty('--vertical-gap-size', `${baseVerticalGap}px`)
      this.showLargeArrow = baseVerticalGap > 110
    },
    resizeHandler: throttle(function () {
      this.computeRowSize()
    }, 100),
    calcNumToAdd(array, targetNum) {
      const remainder = array.length % targetNum;
      if (remainder === 0) {
        return 0; // массив уже делится нацело на целевое число
      } else {
        return targetNum - remainder; // добавляем элементы, чтобы длина массива стала кратной целевому числу
      }
    },
    enrichListV2(arr, size) {
      const chunks = chunk(arr, size).map((sub_array, i) => {
        if (i % 2 !== 0) {
          /* reversed */
          return sub_array.map((item, j) => {
            item.reversed = true
            item.order = (i + 1) * size - (j + 1)
            item.isStartRow = item.order === i * size
            return item
          })
        } else {
          return sub_array.map((item, j) => {
            item.order = i * size + j
            item.isEndRow = item.order === (i + 1) * size - 1
            return item
          })
        }
      })

      return concat(...chunks)

    },
  },
}
